import React from 'react';
import WizardItem, { IWizardItem } from '../WizardItem';
// @ts-ignore
import styles from './WizardTip.module.scss';

interface Props {
	item: IWizardItem;
}

const WizardScreen: React.FC<Props> = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			{item?.settings?.badge?.text && (
				<div className={styles.badge}>{item.settings.badge.text}</div>
			)}
			{item?.settings?.banner?.imageUrl && (
				<div className={styles.imageWrapper}>
					<img src={item.settings.banner.imageUrl} />
				</div>
			)}
			{item?.children?.length && item.children.length > 0 && (
				<div className={styles.content}>
					{item.children.map((child, key) => <React.Fragment key={key}><WizardItem item={child} /></React.Fragment>)}
				</div>
			)}
		</div>
	);
};

export default WizardScreen;